import { Component, OnInit, Input } from '@angular/core';
import { ViewEncapsulation } from '@angular/core';
import { LOGIN_PAGES } from './enum-login-pages';
import { MixpanelService } from '../../services/mixpanel-service/mixpanel.service';

@Component({
  selector: 'app-login-process',
  templateUrl: './login-process.component.html',
  styleUrls: ['./login-process.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class LoginProcessComponent implements OnInit {
  @Input() display = true;
  @Input() currentStep: number = LOGIN_PAGES.EMAIL;
  @Input() registrationEmail = '';
  @Input() applicationType = '';

  // Map enum values to their string representations
  stepNames: Record<LOGIN_PAGES, string> = {
    [LOGIN_PAGES.EMAIL]: 'EMAIL',
    [LOGIN_PAGES.PASSWORD]: 'PASSWORD',
    [LOGIN_PAGES.FORGOT_PASSWORD_EMAIL]: 'FORGOT_PASSWORD_EMAIL',
    [LOGIN_PAGES.CHANGE_PASSWORD]: 'CHANGE_PASSWORD',
    [LOGIN_PAGES.ACCOUNT_CONFIRMED_SCREEN]: 'ACCOUNT_CONFIRMED_SCREEN',
    [LOGIN_PAGES.EMAIL_SENT_SCREEN]: 'EMAIL_SENT_SCREEN',
    [LOGIN_PAGES.PASSWORD_CREATION]: 'PASSWORD_CREATION',
    [LOGIN_PAGES.LINK_EXPIRED]: 'LINK_EXPIRED',
    [LOGIN_PAGES.ACCESS_DENIED]: 'ACCESS_DENIED',
    [LOGIN_PAGES.SIGN_UP_SCREEN]: 'SIGN_UP_SCREEN',
    [LOGIN_PAGES.SIGN_UP_SCREEN_SUCCESS]: 'SIGN_UP_SCREEN_SUCCESS',
  };

  login_enums = LOGIN_PAGES;
  email = '';
  forgotPasswordEmail = '';
  userLocked = false;

  constructor(private mixpanelService: MixpanelService) {
    this.display = true;
  }

  ngOnInit(): void {}

  setStep(step: LOGIN_PAGES) {
    // Get the string representation of the step using the mapping
    const stepName = this.stepNames[step];

    // Track the step dynamically based on the enum value
    /* this.mixpanelService.track({
      id: this.email,
      eventName: `${stepName.toLowerCase()} step entered`,
      eventDisplayName: `${stepName.toLowerCase()} Step Entered`,
      kpi: 'Form Completion Rate',
      trigger: 'On Field Entry',
      eventDefinition: `User enters ${stepName.toLowerCase()} in the form field`,
      propertyType: 'Event Property',
      propertyDefinition: 'Field Label',
    });*/

    this.currentStep = step;
  }

  setEmail(email: string) {
    // set email when leaving email page
    this.email = email;
  }

  setUserLocked(userLocked: boolean) {
    this.userLocked = userLocked;
  }

  setForgotPasswordEmail(email: string) {
    this.forgotPasswordEmail = email;
  }
}
